export interface GoogleMapsAnswer {
  text: string;
  sources: Array<{ name: string; url: string }>;
}

export function googleMapsLink(text: string): string | null {
  const tokens = text.match(/https?:\/\/[^\s<>]+/g) ?? [];
  for (const token of tokens) {
    try {
      const url = new URL(token.replace(/[)\],.]+$/, ''));
      if (url.protocol !== 'https:' || url.username || url.password || (url.port && url.port !== '443')) continue;
      if (url.hostname === 'maps.app.goo.gl' || url.hostname === 'maps.google.com' ||
        (['google.com', 'www.google.com', 'www.google.co.th'].includes(url.hostname) && url.pathname.startsWith('/maps')) ||
        (url.hostname === 'goo.gl' && url.pathname.startsWith('/maps/'))) return url.href;
    } catch { /* A pasted sentence can contain malformed URLs. */ }
  }
  return null;
}

export async function googleMapsSearch(query: string, signal: AbortSignal, near: [number, number] | null): Promise<GoogleMapsAnswer> {
  let token: string | null = null;
  try { token = localStorage.getItem('wayfarer.session'); } catch { /* Cookie auth still works. */ }
  const response = await fetch(`${import.meta.env.BASE_URL}api/google/search`, {
    method: 'POST', signal, credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', ...(token ? { 'X-Wf-Session': token } : {}) },
    body: JSON.stringify({ query, near }),
  });
  const body = await response.json();
  if (!response.ok) throw new Error(body.error || 'Google Maps search is unavailable.');
  if (typeof body.text !== 'string' || !Array.isArray(body.sources)) throw new Error('Google Maps returned an incomplete answer.');
  const sources = body.sources.filter((s: {name?: unknown; url?: unknown}) => typeof s.name === 'string' && typeof s.url === 'string' && googleMapsLink(s.url) === s.url);
  return { text: body.text, sources };
}
